// LIVE / DEMO / PARTIAL data-source pill.
export default function DataSourcePill({ source, testId }) {
  const map = {
    live: { txt: "LIVE", cls: "text-[#00A850] bg-[#00A850]/10 border-[#00A850]/30" },
    partial: { txt: "PARTIAL", cls: "text-[#E3000B] bg-[#E3000B]/10 border-[#E3000B]/30" },
    mock: { txt: "DEMO", cls: "text-gray-500 bg-gray-200/30 border-gray-300" },
  };
  const m = map[source] || map.mock;
  return (
    <span data-testid={testId} title={
      source === "live" ? "Real Amazon + BrickLink data" :
      source === "partial" ? "One side live, other side mock" :
      "Demo data (run Live Refresh to fetch real prices)"
    } className={`inline-flex items-center h-5 px-1.5 rounded-sm font-mono text-[10px] font-bold uppercase border ${m.cls}`}>
      {m.txt}
    </span>
  );
}
